'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var SwipeOut = _interopDefault(require('../swipe-out'));
var actionSheet = _interopDefault(require('../action-sheet/instance'));
var utils = require('../utils');
var getSystem = require('@mx/util/get-system');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "swipe-cell"
    }, [_vm.isIOS ? _c('vix-swipe-out', {
      attrs: {
        "text": _vm.text
      },
      on: {
        "clickButton": _vm.clickButton,
        "clickContent": _vm.clickContent
      }
    }, [_vm._t("default")], 2) : _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap.press",
        modifiers: {
          "press": true
        }
      }],
      staticClass: "swipe-cell-content",
      on: {
        "click": _vm.clickContent,
        "press": _vm.showActionSheet
      }
    }, [_vm._t("default")], 2)], 1);
  },
  staticRenderFns: [],
  name: 'swipe-cell',
  components: _objectSpread({}, SwipeOut.registration),
  props: {
    text: {
      type: String,
      default: '删除'
    }
  },
  data: function data() {
    return {
      isIOS: getSystem.getSystem() === 'ios'
    };
  },
  methods: {
    clickContent: function clickContent() {
      this.$emit('clickContent');
    },
    clickButton: function clickButton() {
      this.$emit('clickButton');
    },
    showActionSheet: function showActionSheet() {
      var _this = this;

      actionSheet.show([{
        text: this.text,
        onClick: function onClick() {
          _this.clickButton();

          actionSheet.hide();
        }
      }, {
        text: '取消',
        onClick: function onClick() {
          actionSheet.hide();
        }
      }]);
    }
  }
});

exports.default = index;
